import { PureAbility } from "@casl/ability";
import { createContext } from "react";

import type { IAllGroupContext, IPermissionsContext } from "./types";

const groupAttributes = new PureAbility<string>();
const groupLevelPermissions = new PureAbility<string>();
const organizationLevelPermissions = new PureAbility<string>();

const authzPermissionsContext = createContext(
  new PureAbility<string, unknown>(),
);

const authzGroupContext = createContext(new PureAbility<string>());

/**
 * Org-scope permissions, explicit and never shadowed by a group route.
 * Read through `useAuthz().canOrg` / `canOrgMutate` / `canOrgResolve`.
 */
const authzOrgPermissionsContext = createContext(
  new PureAbility<string, unknown>(),
);

/**
 * Group-scope permissions, explicit and distinct from the org ones above.
 * Read through `useAuthz().canGroup` / `canGroupMutate` / `canGroupResolve`.
 */
const authzGroupPermissionsContext = createContext(
  new PureAbility<string, unknown>(),
);

const allGroupContext = createContext<IAllGroupContext>({});

const permissionsContext = createContext<IPermissionsContext | undefined>(
  undefined,
);

export {
  groupAttributes,
  groupLevelPermissions,
  organizationLevelPermissions,
  authzPermissionsContext,
  authzGroupContext,
  authzOrgPermissionsContext,
  authzGroupPermissionsContext,
  allGroupContext,
  permissionsContext,
};
